import React from 'react';
import ScrollToTopOnMount from '../../../ScrollToTop';
import HeroSearch from './HeroSearch';
import NewsSection from './NewsSection';
import CooperationForm from './CooperationForm';
import './main.scss';

const Main: React.FC = () => {
  return (
    <div className="main-page">
      <ScrollToTopOnMount />
      <div className="main-page__hero">
        <HeroSearch />
      </div>
      <div className="main-page__content">
        <NewsSection />
        <CooperationForm />
      </div>
    </div>
  );
};

export default Main;
